import { TabPanel } from 'react-tabs';
import styled from 'styled-components';

export const CustomTabPanel = styled(TabPanel)`
  width: 100%;
`;
